"use client";

export default function AdminError({ reset }: { reset: () => void }) {
  return (
    <section className="card">
      <h2>Admin panelinde bir hata olustu</h2>
      <button className="btn btn-primary" onClick={reset}>Tekrar Dene</button>
    </section>
  );
}
